var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickPick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.3525V7.5H6.57L5.25 10.1475V9H2.43L3.75 6.3525ZM5.25 0L0 10.5H3.75V16.5L9 6H5.25V0Z",
    fill: "#2C6B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickPick);
export default __webpack_public_path__ + "static/media/quick-pick.57704fffdb8d60534e8f4e434a8da48d.svg";
export { ForwardRef as ReactComponent };